export const dailiesThemes: Record<
  string,
  { theme: string; description: string }
> = {
  Mon: {
    theme: 'Easy Money Monday',
    description: 'Start off your week with some light brain food!',
  },
  Tue: {
    theme: 'Trash Tuesday',
    description: 'Everything from Nomadland to Nicolas Cage',
  },
  Wed: {
    theme: 'Quiz Whiz Wednesday',
    description: 'Moderately difficult questions from the academic canons',
  },
  Thu: {
    theme: 'Thematic Thursday',
    description: `You'll have to guess on Q10 what tied everything else together!`,
  },
  Fri: {
    theme: 'News of the Week Friday',
    description:
      'Make sure you paid attention to stuff in the news throughout the week!',
  },
  Sat: {
    theme: 'Phone-a-Kid Saturday',
    description: `Normally playing with others helping you is frowned upon, but not this day! You'll want a kid by your side!`,
  },
  Sun: {
    theme: 'Stressful Sunday',
    description: `The hardest trivia questions, your Scratch streaks will be on the line every week`,
  },
};
